<template>
  <div>
    <form class="space-y-6 p-3" @submit.prevent="onSubmit()">
      <div class="flex flex-col gap-3">
        <div class="flex flex-row">
          <span class="w-1/2 text-center">
            Number of Items on List Pages
          </span>
          <SelectionField
            class="w-36 rounded-md !shadow"
            v-model="formValues.numPerPage"
            :options="numPerPageOptions"
          />
        </div>
        <div class="flex flex-row">
          <span class="w-1/2 text-center">
            Number of Items in Tables
          </span>
          <SelectionField
            class="w-36 rounded-md !shadow"
            v-model="formValues.numPerTable"
            :options="numPerTableOptions"
          />
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import SelectionField from './formComponents/SelectionField.vue'

import settings from '../services/settings.js'
import events from '../services/events.js'

import DROPDOWN_LISTS from '../components/DropdownLists.json'

export default {
  components: {
    SelectionField,
  },
  data() {
    return {
      formValues: {
        numPerPage: 0,
        numPerTable: 0,
      },
      numPerPageOptions: [
        10,
        25,
        50,
        100,
        200,
      ],
      numPerTableOptions: [
        50,
        100,
        200,
        500,
        1000,
      ],
      schoolYearOptions: DROPDOWN_LISTS.schoolYears,
    };
  },
  methods: {
    async onSubmit() {
      var prevNumPerPage = {
        studentList: settings.studentList.numPerPage,
        routeList: settings.routeList.numPerPage,
      }
      var prevNumPerTable = {
        oneTimeNoRideList: settings.oneTimeNoRideList.numPerPage,
        dailyNoShowList: settings.dailyNoShowList.numPerPage,
      }

      settings.studentList.numPerPage = parseInt(this.formValues.numPerPage)
      settings.routeList.numPerPage = parseInt(this.formValues.numPerPage)
      settings.oneTimeNoRideList.numPerPage = parseInt(this.formValues.numPerTable)
      settings.dailyNoShowList.numPerPage = parseInt(this.formValues.numPerTable)

      settings.studentList.currentPage = Math.trunc((settings.studentList.currentPage - 1) * prevNumPerPage.studentList / settings.studentList.numPerPage) + 1
      settings.routeList.currentPage = Math.trunc((settings.routeList.currentPage - 1) * prevNumPerPage.routeList / settings.routeList.numPerPage) + 1
      settings.oneTimeNoRideList.currentPage = Math.trunc((settings.oneTimeNoRideList.currentPage - 1) * prevNumPerTable.oneTimeNoRideList / settings.oneTimeNoRideList.numPerPage) + 1
      settings.dailyNoShowList.currentPage = Math.trunc((settings.dailyNoShowList.currentPage - 1) * prevNumPerTable.dailyNoShowList / settings.dailyNoShowList.numPerPage) + 1

      events.trigger('listPageSettingsUpdate', this.formValues.numPerPage)
      this.$emit('update', this.formValues)
    },
  },
  created() {
    this.formValues.numPerPage = settings.studentList.numPerPage
    this.formValues.numPerTable = settings.dailyNoShowList.numPerPage
  }
}
</script>
